export default "__VITE_ASSET__B26m49ro__"